/* eslint-disable */
import React, { PureComponent, lazy, Suspense } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import 'rc-pagination/assets/index.css'

const PaginationRc = lazy(() => import('rc-pagination'))

const Wrapper = styled.div`
  display: flex;
  .rc-pagination-item {
    width: 32px;
    height: 32px;
    line-height: 32px;
    border: 1px solid #848e9c;
    font-size: 13px;
    outline: none;
  }
  .rc-pagination-prev,
  .rc-pagination-next,
  .rc-pagination-jump-prev,
  .rc-pagination-jump-next {
    cursor: pointer;
    color: #212833;
    font-size: 10px;
    border-radius: 6px;
    list-style: none;
    width: 32px;
    height: 32px;
    line-height: 32px;
    float: left;
    text-align: center;
    outline: none;
  }
  .rc-pagination-item:hover {
    border-color: #f0b90b;
  }
  .rc-pagination-item:hover a {
    color: #f0b90b;
  }
  .rc-pagination-item-active {
    background-color: #f0b90b;
    border-color: #f0b90b;
    &:hover a {
      color: #fff;
    }
  }

  .rc-pagination-jump-prev:hover:after,
  .rc-pagination-jump-next:hover:after {
    color: #f0b90b;
  }
`

class Pagination extends PureComponent {
  static propTypes = {
    totalCount: PropTypes.number,
    pageSize: PropTypes.number,
    pageSize: PropTypes.number,
    paging: PropTypes.func,
  }

  static defaultProps = {
    totalCount: 0,
    pageSize: 25,
    current: 1,
    paging: null,
  }

  render() {
    const { totalCount, paging, pageSize, current } = this.props

    return (
      <Wrapper>
        <Suspense fallback="">
          <PaginationRc
            total={totalCount}
            onChange={paging}
            pageSize={pageSize}
            defaultCurrent={1}
          />
        </Suspense>
      </Wrapper>
    )
  }
}

export default Pagination
